import apiClient from 'services/_infra/apiClient';

export async function startService(name, reason = '') {
  try {
    const res = await apiClient.post(`/service-manager/services/${name}/start`, { reason: reason || null });
    return res.data;
  } catch (err) {
    console.error(`Error starting service '${name}':`, err);
    throw err;
  }
}

export async function stopService(name, reason = '') {
  try {
    const res = await apiClient.post(`/service-manager/services/${name}/stop`, { reason: reason || null });
    return res.data;
  } catch (err) {
    console.error(`Error stopping service '${name}':`, err);
    throw err;
  }
}

export async function restartService(name, reason = '') {
  try {
    const res = await apiClient.post(`/service-manager/services/${name}/restart`, { reason: reason || null });
    return res.data;
  } catch (err) {
    console.error(`Error restarting service '${name}':`, err);
    throw err;
  }
}
